module.exports = __webpack_public_path__ + "static/img/imagineword_banner.189a52b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appDownLoad/pc/imagineword_banner.jpg
// module id = SDal
// module chunks = 1